import { type ReactNode } from 'react';
import { View } from 'react-native';

import { Button, type ButtonProps } from './Button';
import { cn } from './cn';
import { Text } from './Text';

export interface EmptyStateProps {
  /** Emoji or custom node shown above the title. */
  icon?: string | ReactNode;
  title: string;
  body?: string;
  /** Primary action button props. */
  action?: ButtonProps;
  /** Quiet secondary hint under the action. */
  hint?: string;
  className?: string;
}

/** Cold-start / empty-list state — icon, copy, one primary action, a quiet hint. */
export function EmptyState({
  icon,
  title,
  body,
  action,
  hint,
  className,
}: EmptyStateProps) {
  return (
    <View className={cn('items-center px-8 py-12', className)}>
      {icon ? (
        typeof icon === 'string' ? (
          <Text className="mb-4 text-5xl">{icon}</Text>
        ) : (
          <View className="mb-4">{icon}</View>
        )
      ) : null}
      <Text variant="title" className="text-center">
        {title}
      </Text>
      {body ? (
        <Text variant="subtitle" className="mt-2 text-center">
          {body}
        </Text>
      ) : null}
      {action ? <Button className="mt-6" {...action} /> : null}
      {hint ? (
        <Text variant="caption" className="mt-4 text-center text-faint">
          {hint}
        </Text>
      ) : null}
    </View>
  );
}
